import { Component, OnInit, OnDestroy } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  first,
  map,
  mergeMap,
  tap
} from 'rxjs/operators';
import {
  IFilterComboComponent,
  IFilterTextComponent,
  LoggedComponent,
  LoggerService,
  RankSortingTypeEnum,
  RecordListLocator,
  ViewDataConfigStruct,
  ViewDataInterface,
  ViewDataService,
  DatabaseService
} from 'world-archery-lib';
import { RecordItem } from 'world-archery-lib';
import { FiltersWorldRecordsService } from '../../services/filters-world-records.service';
import { MODULE_VERSION } from 'src/app/world-ranking-statistics/token.version';
import { VersionService } from 'src/app/world-ranking-statistics/version.service';

@Component({
  selector: 'app-world-records-list',
  templateUrl: './world-records-list.component.html',
  styleUrls: ['./world-records-list.component.scss'],
  providers: [{ provide: MODULE_VERSION, useValue: 'WorldRecordsListComponent' }, VersionService]
})
export class WorldRecordsListComponent extends LoggedComponent
  implements OnInit {
  loading = true;
  RankingView: ViewDataInterface;
  RankingsList: Array<RecordItem> = [];
  constructor(
    protected logger: LoggerService,
    protected views: ViewDataService,
    public filter_service: FiltersWorldRecordsService,
    private refreshService: VersionService,
    public db: DatabaseService
  ) {
    super(logger);
  }
  ngOnInit() {
    this.getDataStream().subscribe(next => {
      this.RankingsList = next;
      this.loading = false;
    });
  }
  getDataStream(): Observable<Array<RecordItem>> {
    if (this.refreshService.mustRefresh) {
      this.db.truncate();
    }
    return combineLatest(
      this.filter_service.comboCategoryStore.filterInfo.options.options_selected_subject.asObservable(),
      this.filter_service.comboText.data(400),
      this.filter_service.orderValue,
      this.filter_service.comboCategoryStore.historicalComboRef.comboData,
      this.filter_service.comboCategoryStore.levelComboRef.comboData
    ).pipe(
      mergeMap(([category, text, order, isHistoric, levelCombo]) => {
        if(category == undefined){
          return of([]);
        }
        const categoriesLocatorByRecords = new RecordListLocator();
        categoriesLocatorByRecords.sortrank.sortingType = order
          ? order.sortingType
          : undefined;
        categoriesLocatorByRecords.sortrank.asc = order
          ? order.asc
          : undefined;
        categoriesLocatorByRecords.sortrank['_value'] = order
          ? order.sortingType
          : undefined;
        categoriesLocatorByRecords.category['value'] = category ? category.CatCode : undefined;
        categoriesLocatorByRecords.search.value = text.text;
        categoriesLocatorByRecords.team.isTeam = Boolean(category.IsTeam);
        categoriesLocatorByRecords.recordLevel.value = Number(levelCombo.RecordLevelId);
        categoriesLocatorByRecords.isPara.value = "1|0" as any;
        categoriesLocatorByRecords.disciplineId.value = category.RecordDiscipline;
        categoriesLocatorByRecords.isHistorical.value = Boolean(isHistoric.Name === 'Historic' ? 1 : 0);

        const view = this.views.get(categoriesLocatorByRecords);
        const infoItem: ViewDataConfigStruct = {
          maxAge: 1800,
          interval: 1000,
          autorefresh: false,
          expectedItems: 30
        };
        view.applyConfiguration(infoItem);
        return view.getDataStream();
      })
    );
  }

  loadMore() {
    this.RankingView.incrementExpectedItemNumber(10);
    this.loading = true;
  }

  get defaultValueMessage() {
    return (
      this.filter_service.comboCategoryStore.filterInfo.options.options_subject.asObservable()
    )
      .pipe(
        map(a => {
          if (a.length === 0) {
            return 'adjust_parameters';
          } else {
            return '';
          }
        })
      );
  }
  changeSort(category: string
  ) {
    if (category === undefined) {
      this.filter_service.sortLocator.sortingType = undefined;
      this.filter_service.sortLocator.asc = true;
    } else {
      if (category === this.filter_service.sortLocator.sortingType) {
        if (this.filter_service.sortLocator.asc === false) {
          this.filter_service.sortLocator.sortingType = undefined;
        }
        this.filter_service.sortLocator.asc = !this.filter_service.sortLocator
          .asc;
      } else {
        this.filter_service.sortLocator.sortingType = category as any;
        this.filter_service.sortLocator.asc = true;
      }
    }
    this.filter_service.modifyOrderValue();
  }
  rankingSort() {
    if (this.filter_service.sortLocator.sortingType === undefined) {
      return 'asc';
    } else {
      return 'desc';
    }
  }
  sortClass(category: string
  ) {
    if (this.filter_service.sortLocator.sortingType !== category) {
      return '';
    }
    return this.filter_service.sortLocator.asc === true ? 'asc' : 'desc';
  }
}
